module.exports = __webpack_public_path__ + "static/media/avtare-user.e24475f4.svg";